import { render, staticRenderFns } from "./ObiLocationCard.vue?vue&type=template&id=f174405e&scoped=true&"
import script from "./ObiLocationCard.vue?vue&type=script&lang=js&"
export * from "./ObiLocationCard.vue?vue&type=script&lang=js&"
import style0 from "./ObiLocationCard.vue?vue&type=style&index=0&id=f174405e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f174405e",
  null
  
)

export default component.exports